import React, { Component } from 'react';
import "../styles/Feed.css"
class Feed extends Component {
  render() {
    return (
        <div class="grid gap-x-6 gap-y-6 grid-cols-3">
        <div class="container"> <img class="img"
      src="https://images.unsplash.com/photo-1478512611414-50d132a6dcd3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTh8fHdpbGRlcm5lc3MlMjBjdWx0dXJlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
      alt="new"
 
      /></div>

        <div><img class="img"
      src="https://images.unsplash.com/photo-1628676895539-a8fa23f356da?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjB8fHdpbGRlcm5lc3MlMjBjdWx0dXJlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
      alt="new"
      /></div>

        <div><img class="img"
      src="https://media.istockphoto.com/photos/beautiful-sportive-dog-laying-on-the-ground-in-the-forest-picture-id1337017618?b=1&k=20&m=1337017618&s=170667a&w=0&h=Fwjwd7dv8yUzDMhcyZR0OEIlaqn3lzDCSd7wf-bUNjg="
      alt="new"
      /></div>


        <div><img class="img"
      src="https://media.istockphoto.com/photos/alberta-canada-countryside-picture-id1387323765?b=1&k=20&m=1387323765&s=170667a&w=0&h=kUIKroh40gRFVk5nu8167jPWoDUWB7t-t0nGWaSl4oM="
      alt="new"
      /></div>

      
        <div><img class="img"
      src="https://media.istockphoto.com/photos/tamarindo-beach-and-estuary-guanacaste-costa-rica-picture-id1400858774?b=1&k=20&m=1400858774&s=170667a&w=0&h=lonY0W2axbCWoNybjZ4CoVMoPRml4j4bKJkf8KkPQwg="
      alt="new"
      /></div>

        <div><img class="img"
      src="https://images.unsplash.com/photo-1469474968028-56623f02e42e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8bmF0dXJlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
      alt="new"
      /></div>

      </div>      
    );
  }
}
 
export default Feed;